import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'

import TmpSupplierApiUrls from 'src/apiUrls/TmpSupplierApiUrls'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/PathMap_TmpAdmin'

const {
  form: {
    CngEditFormButtonSection
  },
  button: { CngSecondaryButton },
  CngGridItem
} = components

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification }) {
  const { id } = useParams()

  return (

    <CngEditForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      bodySection={
        <FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"edit"}
          id={id}
        />
      }
      renderButtonSection={() => (
        <CngEditFormButtonSection>
          <CngGridItem>
            <CngSecondaryButton
              onClick={() => { history.push(pathMap.SUPPLIER_LIST_VIEW) }}>
              {'Cancel'}
            </CngSecondaryButton>
          </CngGridItem>
        </CngEditFormButtonSection>
      )}
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}
      fetch={{
        url: TmpSupplierApiUrls.LIST
      }}
      update={{
        url: TmpSupplierApiUrls.EDIT,
        successRedirect: pathMap.SUPPLIER_LIST_VIEW
      }}
      id={id}
    />
  )

}

export default EditPage
